import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function formComparisonValidator<T>(
  comparisonKeys: (keyof T)[],
  comparisonType: 'greater' | 'lower',
  canBeEqual: boolean = false,
  type: 'date' | 'datetime' | 'number' = 'date'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const referenceValue = parseValue(control.value, type);

    if (referenceValue === null) {
      return type === 'number'
        ? { invalidNumber: true }
        : { invalidDate: true };
    }

    for (const key of comparisonKeys) {
      const compareControl = control.parent.get(key as string);
      if (
        !compareControl ||
        compareControl.value === null ||
        compareControl.value === undefined
      )
        continue;

      const compareValue = parseValue(compareControl.value, type);
      if (compareValue === null) {
        return type === 'number'
          ? { invalidNumber: true }
          : { invalidDate: true };
      }

      if (
        !compareValues(referenceValue, compareValue, comparisonType, canBeEqual)
      ) {
        return type === 'number'
          ? { numberComparison: true }
          : { dateComparison: true };
      }
    }

    return null;
  };
}

function parseValue(
  value: any,
  type: 'date' | 'datetime' | 'number'
): number | null {
  if (type === 'date' || type === 'datetime') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date.getTime();
  } else if (type === 'number') {
    const number = parseFloat(value);
    return isNaN(number) ? null : number;
  }
  return null;
}

function compareValues(
  referenceValue: number,
  compareValue: number,
  comparisonType: 'greater' | 'lower',
  canBeEqual: boolean
): boolean {
  if (comparisonType === 'greater') {
    return canBeEqual
      ? referenceValue >= compareValue
      : referenceValue > compareValue;
  } else if (comparisonType === 'lower') {
    return canBeEqual
      ? referenceValue <= compareValue
      : referenceValue < compareValue;
  }
  return false;
}
